var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":_vm.rules,"label":_vm.label,"type":"number","required":_vm.required,"dense":_vm.dense,"readonly":_vm.readonly,"disabled":_vm.disabled},on:{"input":_vm.onInput},model:{value:(_vm.percentage),callback:function ($$v) {_vm.percentage=$$v},expression:"percentage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }